<div class="toolbox-component" id="text-edit">
  <div class="header">
    <div class="header-title">
      <span class="header-title-main">
        {{ 'i18n.toolbox.textEdit.title' | translate }}
      </span>
      @if (placeholders.length > 0) {
        <span class="header-title-sub">
          ({{ placeholders.length }})
        </span>
      }
    </div>
    <mat-icon svgIcon="close"
      class="close-x"
    (click)="btnCloseClick()"></mat-icon>
  </div>
  <div class="toolbox-body">
    <div class="content">
      @if (placeholders.length === 0) {
        <div class="icon">
          <mat-icon svgIcon="empty-text"></mat-icon>
        </div>
        <div class="message">
          <div class="message-title">
            {{ 'i18n.toolbox.textEdit.noPlaceholdersTitle' | translate }}
          </div>
          <div class="message-content">
            {{ 'i18n.toolbox.textEdit.noPlaceholdersMessage' | translate }}
          </div>
        </div>
      }
      @if (isCreateNewButtonVisible) {
        <button
          class="primary"
          (click)="createNewTextPlaceholder()">
          <mat-icon svgIcon="text-add"></mat-icon>
          {{ 'i18n.toolbox.textEdit.noPlaceholdersButton' | translate }}
        </button>
      }
      <div class="placeholders">
        @for (placeholder of placeholders; track placeholder) {
          <div class="placeholder">
            <div class="placeholder-text"
                 [style.font-family]="placeholder.getFontFamily()">
              {{ placeholder.getPlaintext() }}
            </div>
            <mat-icon (click)="placeholder.clickEvent()"
                      svgIcon="text-edit"></mat-icon>
            @if (placeholder.isFlexible()) {
              <mat-icon (click)="placeholder.remove()"
                        svgIcon="text-delete"></mat-icon>
            }
          </div>
          <div class="divider"></div>
        }
      </div>
    </div>
  </div>
</div>
